import { render } from "./login.vue?vue&type=template&id=dc5efa76"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
script.render = render

export default script